import { MainColor } from '../../palette/colors';

export const getCompetencesMatrixTheme = () => {
  return {
    levelBox: {
      background: 'coolGrey5' satisfies MainColor as MainColor,
      border: 'coolGrey20' satisfies MainColor as MainColor,
    },
    header: {
      title: 'navy95' satisfies MainColor as MainColor,
      subtitle: 'coolGrey60' satisfies MainColor as MainColor,
    },
  };
};

export type CompetencesMatrixTheme = ReturnType<typeof getCompetencesMatrixTheme>;
